import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Message, MessageService, SelectItemGroup } from 'primeng/api';
import { FormValidation } from 'src/app/libs/ruvpp-angular2-comun/FormValidation';
import { HttpSession } from 'src/app/libs/ruvpp-angular2-comun/HttpSession';
import { SimuladorService } from './../../datos/simulador.service';
import { JsonResponse } from './../../libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from './../../libs/ruvpp-angular2-comun/ServicioAlertas';
import { DatosElementoDTO, DocumentoDTO, ElementoDTO, EspacioDTO, EspacioForm, InputActualizarEstatusDocumento, InputActualizarEstatusEspacio, InputActualizarEstatusPrototipo, InputAgregarEspacio, InputAgregarPrototipo, InputObtenerEspacioDetalle, InputObtenerPrototipoDetalle, OutputAgregarEspacio, OutputAgregarPrototipo, OutputConsultaUsuario, OutputObtenerCostoManoObra, OutputObtenerElementos, OutputObtenerEspacioDetalle, OutputObtenerPrototipoDetalle,  PrototipoDTO, PrototipoForm } from './../../modelo';

@Component({
    selector: 'app-administrador',
    templateUrl: './administrador.component.html'
    //,styleUrls: ['./administrador.component.css']
})
export class AdministradorComponent implements OnInit {

    public progressSpinner: boolean;

    public usuario: OutputConsultaUsuario;
    public idElemento: number | null;
    public idEspacio: number | null;
    public grupoElementos: SelectItemGroup[];
    public datosElemento: DatosElementoDTO;
 
    //public listPrecioUnitario: OutputObtenerPrecioUnitario[];
    //public listPrecioUnitarioEspacio: OutputObtenerPrecioUnitarioEspacio[];
    public listCostoManoObra: OutputObtenerCostoManoObra[];
    //public listTotalManoObra: OutputObtenerTotalManoObra[];
    //public listTotalMateriales: OutputObtenerTotalMateriales[];

    public grupoEspacios: SelectItemGroup[];
    public espacio: EspacioDTO;
    public prototipo: PrototipoDTO;

    //Simulador

    public simuladorForm: EspacioForm;

    //Espacio

    public espacioForm: EspacioForm;


    //Prototipo

    @ViewChild('fileUpload') fileUpload: any;
    public prototipoForm: PrototipoForm;
    public uploadedFiles: any[] = [];
    public msgs: Message[] = [];

    //Otros

    public tabPrincipal: number = 0;


    /**
     * 
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private messageService: MessageService, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        console.log('AdministradorComponent -->> ', new Date())
    }

    ngOnInit(): void {

        this.loading();

        this.initSimuladorForm();

        this.initEspacioForm()

        this.initPrototipoForm();

        this.usuario = HttpSession.getAttribute('USER');

    }

    /**
    * 
    */
    private initSimuladorForm() {
        this.simuladorForm = <EspacioForm>{ nombreEspacio_MensajeError: new FormValidation(null), tab: 0, listaElementos: [] };
    }

    /**
     * 
     */
    private initEspacioForm() {
        this.espacioForm = <EspacioForm>{ nombreEspacio_MensajeError: new FormValidation(null), tab: 0, listaElementos: [] };
    }

    /**
     * 
     */
    private initPrototipoForm() {
        this.prototipoForm = <PrototipoForm>{
            listEspacioSelect: []
            , nombrePrototipo_MensajeError: new FormValidation(null)
            , tab: 0
            , prototipoDetalle: <OutputObtenerPrototipoDetalle>{ listDocumento: [], listEspacioxPrototipo: [] }
            , listPrototipos: []
            , espacioForm: <EspacioForm>{ nombreEspacio_MensajeError: new FormValidation(null) }
        };


    }

    /**
     * 
     * 
     */
    private loading(): void {

        this.service.ObtenerElementos().subscribe((resultado: JsonResponse<DatosElementoDTO>) => {

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                this.datosElemento = resultado.model;

                this.grupoElementos = [];

                for (let tipoElemento of this.datosElemento.listTipoElementos) {

                    let filter: any = this.datosElemento.listElementos.filter(row => row.idTipoElemento == tipoElemento.idTipoElemento);

                    let items: any[] = [];

                    for (let elemento of filter) {
                        items.push({ label: elemento.nombreElemento, value: elemento.idElemento });
                    }

                    let dato: any = {
                        label: tipoElemento.nombreTipoElemento,
                        items: items
                    };


                    this.grupoElementos.push(dato);

                }


            }

        });

        this.ObtenerListaEspacio();
        this.ObtenerListaPrototipos();
    }


    public _addElemento(): ElementoDTO {

        let entity: OutputObtenerElementos = this.datosElemento.listElementos.filter(row => row.idElemento == this.idElemento)[0];

        let elemento: ElementoDTO = <ElementoDTO>{
            idElemento: entity.idElemento,
            nombreElemento: entity.nombreElemento,
            clave: entity.clave,
            idTipoDatoEntrada: entity.idTipoDatoEntrada,
            idTipoElemento: entity.idTipoElemento,
            unidadMedida: entity.unidadMedida,
            nombreTipoDatoEntrada: entity.nombreTipoDatoEntrada,
            nombreTipoElemento: entity.nombreTipoElemento,
            idManoObra: entity.idManoObra,
            largo: 0,
            anchoCantidad: 0
        };

        if (elemento.idTipoDatoEntrada == 1) {
            elemento.largo = 1;
        }

        return elemento;
    }

    /**
     * 
     */
    public addElemento(): void {

        let elemento: ElementoDTO = this._addElemento();

        this.simuladorForm.listaElementos.push(elemento);
    }

    /**
    * 
    * @param entity
    */
    public deleteElemento(entity: ElementoDTO): void {

        const index = this.simuladorForm.listaElementos.findIndex(user => user == entity);

        this.simuladorForm.listaElementos.splice(index, 1);

    }

   // /**
   //  * 
   //  * 
   //  */
   // public precioUnitario() {

   //     if (this.simuladorForm.listaElementos != null && this.simuladorForm.listaElementos.length > 0) {

   //         let idElementos: number[] = [];

   //         for (let elemento of this.simuladorForm.listaElementos) {
   //             idElementos.push(elemento.idElemento);
   //         }

   //         this.service.ObtenerPrecioUnitario(idElementos).subscribe((resultado: JsonResponse<OutputObtenerPrecioUnitario[]>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                 this.listPrecioUnitario = resultado.model;
   //                 this.calcular();
   //             }

   //         });

   //     }

   // }

   // /**
   //  * 
   //  */
   // public PrecioUnitarioElemento() {

   //     console.log('PrecioUnitarioElemento -->> ')

   //     if (this.simuladorForm.listaElementos != null && this.simuladorForm.listaElementos.length > 0) {

   //         let idElementos: number[] = [];

   //         for (let elemento of this.simuladorForm.listaElementos) {
   //             idElementos.push(elemento.idElemento);
   //         }

   //         let precioUnitarioEspacio: InputObtenerPrecioUnitarioEspacio = <InputObtenerPrecioUnitarioEspacio>{ listElementos: idElementos, listEspacios: null };

   //         this.service.ObtenerPrecioUnitarioEspacio(precioUnitarioEspacio).subscribe((resultado: JsonResponse<OutputObtenerPrecioUnitarioEspacio[]>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                 this.listPrecioUnitarioEspacio = resultado.model;
   //                 this.calcular();
   //             }

   //         });

   //     }

   // }

   // /**
   //  * 
   //  */
   // public PrecioUnitarioEspacio() {

   //     if (this.simuladorForm.listEspacios != null && this.simuladorForm.listEspacios.length > 0) {

   //         let idEspacio: number[] = [];

   //         for (let espacio of this.simuladorForm.listEspacios) {
   //             idEspacio.push(espacio.idEspacio);
   //         }

   //         let precioUnitarioEspacio: InputObtenerPrecioUnitarioEspacio = <InputObtenerPrecioUnitarioEspacio>{ listElementos: null, listEspacios: idEspacio };

   //         this.service.ObtenerPrecioUnitarioEspacio(precioUnitarioEspacio).subscribe((resultado: JsonResponse<OutputObtenerPrecioUnitarioEspacio[]>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                 this.listPrecioUnitarioEspacio = resultado.model;
   //                 this.calcular();
   //             }

   //         });

   //     }

   // }

   // /**
   //  * 
   //  * 
   //  */
   // public costoManoObra() {

   //     if (this.simuladorForm.listaElementos != null && this.simuladorForm.listaElementos.length > 0) {

   //         let idElementos: number[] = [];

   //         for (let elemento of this.simuladorForm.listaElementos) {
   //             idElementos.push(elemento.idElemento);
   //         }

   //         this.service.ObtenerCostoManoObra(idElementos).subscribe((resultado: JsonResponse<OutputObtenerCostoManoObra[]>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                 this.listCostoManoObra = resultado.model;
   //                 this.calcular();
   //             }

   //         });


   //     }
   // }

   // /**
   //  * 
   //  */
   // public TotalManoObraEspacio() {

   //     this.TotalManoObra(this.espacio.idEspacio, null);
   // }

   // /**
   //  * 
   //  */
   // public TotalManoObraPrototipo() {

   //     this.TotalManoObra(null, this.prototipo.idPrototipo);
   // }

   // /**
   //  * 
   //  * @param idEspacio
   //  * @param idPrototipo
   //  */
   // public TotalManoObra(idEspacio?: number, idPrototipo?: number) {

   //     let idEspacios: number[] = [];

   //     if (idEspacio != null && idEspacio > 0) {

   //         idEspacios.push(idEspacio);

   //         let totalManoObra: InputObtenerTotalManoObra = <InputObtenerTotalManoObra>{ listEspacios: idEspacios };

   //         this.service.ObtenerTotalManoObra(totalManoObra).subscribe((resultado: JsonResponse<OutputObtenerTotalManoObra[]>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                 this.listTotalManoObra = resultado.model;
   //             }

   //         });
   //     }

   //     if (idPrototipo != null && idPrototipo > 0) {

   //         let prototipoDetalle: InputObtenerPrototipoDetalle = <InputObtenerPrototipoDetalle>{ idPrototipo: idPrototipo };

   //         this.service.ObtenerPrototipoDetalle(prototipoDetalle).subscribe((resultado: JsonResponse<OutputObtenerPrototipoDetalle>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {

   //                 if (resultado.model.listEspacioxPrototipo != null) {

   //                     for (let row of resultado.model.listEspacioxPrototipo) {

   //                         idEspacios.push(row.idEspacio);

   //                     }

   //                     let totalManoObra: InputObtenerTotalManoObra = <InputObtenerTotalManoObra>{ listEspacios: idEspacios };

   //                     this.service.ObtenerTotalManoObra(totalManoObra).subscribe((resultado: JsonResponse<OutputObtenerTotalManoObra[]>) => {

   //                         if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                             this.listTotalManoObra = resultado.model;
   //                         }

   //                     });

   //                 }


   //             }

   //         });

   //     }

   // }

   // /**
   //  * 
   //  * @param espacio
   //  */
   // public TotalMaterialesEspacio() {

   //     this.TotalMateriales(this.espacio.idEspacio);
   // }

   // /**
   //* 
   //* @param espacio
   //*/
   // public TotalMaterialesPrototipo() {

   //     this.TotalMateriales(null, this.prototipo.idPrototipo);
   // }

   // /**
   //  * 
   //  * @param idEspacio
   //  * @param idPrototipo
   //  */
   // public TotalMateriales(idEspacio?: number, idPrototipo?: number) {

   //     let idEspacios: number[] = [];

   //     if (idEspacio != null && idEspacio > 0) {

   //         idEspacios.push(idEspacio);

   //         let totalManoObra: InputObtenerTotalMateriales = <InputObtenerTotalMateriales>{ listEspacios: idEspacios };

   //         this.service.ObtenerTotalMateriales(totalManoObra).subscribe((resultado: JsonResponse<OutputObtenerTotalMateriales[]>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                 this.listTotalMateriales = resultado.model;
   //             }

   //         });
   //     }

   //     if (idPrototipo != null && idPrototipo > 0) {

   //         let prototipoDetalle: InputObtenerPrototipoDetalle = <InputObtenerPrototipoDetalle>{ idPrototipo: idPrototipo };

   //         this.service.ObtenerPrototipoDetalle(prototipoDetalle).subscribe((resultado: JsonResponse<OutputObtenerPrototipoDetalle>) => {

   //             if (resultado != null && resultado.code == 200 && resultado.model != null) {

   //                 if (resultado.model.listEspacioxPrototipo != null) {

   //                     for (let row of resultado.model.listEspacioxPrototipo) {

   //                         idEspacios.push(row.idEspacio);

   //                     }

   //                     let totalManoObra: InputObtenerTotalMateriales = <InputObtenerTotalMateriales>{ listEspacios: idEspacios };

   //                     this.service.ObtenerTotalMateriales(totalManoObra).subscribe((resultado: JsonResponse<OutputObtenerTotalMateriales[]>) => {

   //                         if (resultado != null && resultado.code == 200 && resultado.model != null) {
   //                             this.listTotalMateriales = resultado.model;
   //                         }

   //                     });

   //                 }


   //             }

   //         });

   //     }

   // }


    /**
     * 
     * 
     */
    //public calcular(): void {

    //    if (this.simuladorForm.listaElementos != null && this.simuladorForm.listaElementos.length > 0) {

    //        for (let entity of this.simuladorForm.listaElementos) {

    //            let cantidad: number = 0;

    //            if (entity.idTipoDatoEntrada == 1) {
    //                cantidad = entity.anchoCantidad;
    //            }

    //            if (entity.idTipoDatoEntrada == 2) {
    //                cantidad = entity.largo * entity.anchoCantidad;
    //            }


    //            if (this.listPrecioUnitario != null && this.listPrecioUnitario.length > 0) {

    //                let filter = this.listPrecioUnitario.filter(row => row.clave == entity.clave);

    //                if (filter != null && filter.length > 0) {

    //                    for (let row of filter) {
    //                        row.costoElementoxCantidad = row.costoElemento * cantidad;
    //                    }

    //                }
    //            }

    //            if (this.listCostoManoObra != null && this.listCostoManoObra.length > 0) {

    //                let filter = this.listCostoManoObra.filter(row => row.clave == entity.clave);

    //                if (filter != null && filter.length > 0) {

    //                    for (let row of filter) {
    //                        row.costoElemento132xCantidad = row.costoElemento132 * cantidad;
    //                    }

    //                }

    //            }

    //            if (this.listPrecioUnitarioEspacio != null && this.listPrecioUnitarioEspacio.length > 0) {

    //                let filter = this.listPrecioUnitarioEspacio.filter(row => row.clave == entity.clave);

    //                if (filter != null && filter.length > 0) {

    //                    for (let row of filter) {
    //                        // row.costoElemento132xCantidad = row.costoElemento132 * cantidad;
    //                    }

    //                }

    //            }



    //        }

    //    }

    //}

    public salir(): void {
        HttpSession.clear();
        HttpSession.forward(this._router, 'login');
    }

    /**
    * 
    * 
    */
    public addElementoEspacio(): void {

        let elemento: ElementoDTO = this._addElemento();

        this.espacioForm.listaElementos.push(elemento);

    }

    /**
     * 
     * @param entity
     */
    public deleteElementoEspacio(entity: ElementoDTO): void {

        const index = this.espacioForm.listaElementos.findIndex(user => user == entity);

        this.espacioForm.listaElementos.splice(index, 1);

    }

    /**
     * 
     */
    public saveEspacio(): void {

        if (!this.validarFormumlario()) {

            let espacio: InputAgregarEspacio = <InputAgregarEspacio>{ idEspacio: this.espacioForm.idEspacio, nombreEspacio: this.espacioForm.nombreEspacio, idTipoEspacio: 1, listElementos: this.espacioForm.listaElementos };

            this.service.AgregarEspacio(espacio).subscribe((resultado: JsonResponse<OutputAgregarEspacio>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {

                    this.ObtenerListaEspacio();

                    this.espacioForm.tab = 0;

                    this.initEspacioForm()

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Información guardada correctamente ...`,
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                    })

                } else {

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Error al guardar la información...`,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                    })

                }

            });

        }

    }

    /**
     
     */
    private ObtenerListaEspacio(): void {

        //this.service.ObtenerEspacio().subscribe((resultado: JsonResponse<OutputObtenerEspacio>) => {

        //    if (resultado != null && resultado.code == 200 && resultado.model != null) {

        //        this.espacioForm.listEspacios = resultado.model.listEspacios;

        //        this.grupoEspacios = [];


        //        //Obteniendo Tipo de Espacio

        //        let listTipoEspacio: TipoEspacioDTO[] = [];
        //        {

        //            for (let espacio of this.espacioForm.listEspacios) {

        //                let filter = listTipoEspacio.filter(row => row.nombreTipoEspacio == espacio.nombreTipoEspacio);

        //                if (filter != null && filter.length == 0) {

        //                    let tipoEspacio: TipoEspacioDTO = <TipoEspacioDTO>{ nombreTipoEspacio: espacio.nombreTipoEspacio }

        //                    listTipoEspacio.push(tipoEspacio);
        //                }
        //            }

        //        }

        //        for (let tipoEspacio of listTipoEspacio) {

        //            let filter: any = this.espacioForm.listEspacios.filter(row => row.nombreTipoEspacio == tipoEspacio.nombreTipoEspacio);

        //            let items: any[] = [];

        //            for (let espacio of filter) {
        //                items.push({ label: espacio.nombreEspacio, value: espacio.idEspacio });
        //            }

        //            let dato: any = {
        //                label: tipoEspacio.nombreTipoEspacio,
        //                items: items
        //            };

        //            this.grupoEspacios.push(dato);

        //        }


        //    }

        //});

    }

    /**
     * 
     * @param tipo
     */
    public actualizarErrores(tipo: string) {

        switch (tipo) {

            case 'NombreEspacio':

                this.espacioForm.nombreEspacio_MensajeError = new FormValidation(this.espacioForm.nombreEspacio).requered('El nombre del espacio es obligatorio.');

                break;

            case 'NombrePrototipo':

                this.prototipoForm.nombrePrototipo_MensajeError = new FormValidation(this.prototipoForm.nombrePrototipo).requered('El nombre del prototipo es obligatorio.');

                break;

        }

    }

    /**
     * 
     */
    public validarFormumlario(): boolean {

        var error = false;

        this.espacioForm.nombreEspacio_MensajeError = new FormValidation(this.espacioForm.nombreEspacio).requered('El nombre del espacio es obligatorio.');

        if (this.espacioForm.nombreEspacio_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     * @param entity
     */
    public detalleEspacio(entity: EspacioDTO): void {

        this.espacio = entity;

        this.espacioForm.typeView = 'Detalle';

        this.espacioForm.tab = 1;

        this.getEspacio(this.espacioForm, entity);
    }

    /**
     * 
     * @param entity
     */
    public async cloneEspacio(entity: EspacioDTO) {

        this.espacioForm.typeView = 'Clonar';

        this.espacioForm.tab = 1;

        this.getEspacio(this.espacioForm, entity);
    }

    /**
     * 
     * @param entity
     */
    public async editarEspacio(entity: EspacioDTO) {

        this.espacioForm.typeView = 'Editar';

        this.espacioForm.tab = 1;

        this.getEspacio(this.espacioForm, entity);

    }

    /**
     *
     */
    private ObtenerListaPrototipos(): void {

        //this.service.ObtenerPrototipo().subscribe((resultado: JsonResponse<OutputObtenerPrototipo>) => {

        //    if (resultado != null && resultado.code == 200 && resultado.model != null) {

        //        this.prototipoForm.listPrototipos = resultado.model.listPrototipo;

        //    }

        //});

    }

    /**
    * 
    * 
    */
    public addEspacioPrototipo(): void {

        if (this.idEspacio != null) {
            let entity: EspacioDTO = this.espacioForm.listEspacios.filter(row => row.idEspacio == this.idEspacio)[0];
            this.prototipoForm.listEspacioSelect.push(entity);
        }

    }

    /**
     * 
     * @param entity
     */
    public deleteEspacioPrototipo(entity: EspacioDTO): void {
        this.prototipoForm.listEspacioSelect = this.prototipoForm.listEspacioSelect.filter(row => row.idEspacio != entity.idEspacio);
    }

    /**
     * 
     */
    public validarFormumlarioPrototipo(): boolean {

        var error = false;

        this.prototipoForm.nombrePrototipo_MensajeError = new FormValidation(this.prototipoForm.nombrePrototipo).requered('El nombre del prototipo es obligatorio.');

        if (this.prototipoForm.nombrePrototipo_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     */
    public savePrototipo(): void {

        if (!this.validarFormumlarioPrototipo()) {

            let idEspacios: Array<number> = [];

            for (let row of this.prototipoForm.listEspacioSelect) {

                idEspacios.push(row.idEspacio);
            }

            let entity: InputAgregarPrototipo = <InputAgregarPrototipo>{

                idPrototipo: this.prototipoForm.idPrototipo
                , nombrePrototipo: this.prototipoForm.nombrePrototipo
                , idTipoPrototipo: 1
                , idEspacios: idEspacios
            };

            this.service.AgregarPrototipo(entity).subscribe((resultado: JsonResponse<OutputAgregarPrototipo>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {

                    this.ObtenerListaPrototipos();

                    this.prototipoForm.tab = 0;

                    this.initPrototipoForm()

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Información guardada correctamente ...`,
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                    })

                } else {

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Error al guardar la información...`,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                    })

                }

            });

        }

    }

    /**
     * 
     * @param entity
     * @param typeView
     */
    private getPrototipo(entity: PrototipoDTO, typeView: string): void {

        let dato: InputObtenerPrototipoDetalle = <InputObtenerPrototipoDetalle>{ idPrototipo: entity.idPrototipo };

        this.service.ObtenerPrototipoDetalle(dato).subscribe((resultado: JsonResponse<OutputObtenerPrototipoDetalle>) => {

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                this.prototipoForm.prototipoDetalle = resultado.model;

                this.prototipoForm.listEspacioSelect = [];

                for (let espacioxPrototipo of this.prototipoForm.prototipoDetalle.listEspacioxPrototipo) {

                    let filter = this.espacioForm.listEspacios.filter(row => row.idEspacio == espacioxPrototipo.idEspacio);

                    if (filter != null && filter.length > 0) {
                        this.prototipoForm.listEspacioSelect.push(filter[0]);
                    }

                }

                this.prototipoForm.nombrePrototipo = null;
                this.prototipoForm.idPrototipo = null;
                this.prototipoForm.nombrePrototipo_MensajeError = new FormValidation(null);

                if (typeView == 'Detalle' || typeView == 'Editar') {
                    this.prototipoForm.nombrePrototipo = this.prototipoForm.prototipoDetalle.prototipo.nombrePrototipo;
                    this.prototipoForm.idPrototipo = this.prototipoForm.prototipoDetalle.prototipo.idPrototipo;
                }

                if (typeView == 'Clonar') {
                    this.prototipoForm.prototipoDetalle.listDocumento = [];
                }

                this.prototipoForm.tab = 1;

            }

        });

    }

    /**
     * 
     * @param entity
     */
    public detallePrototipo(entity: PrototipoDTO): void {

        this.prototipo = entity;

        this.prototipoForm.typeView = 'Detalle';

        this.getPrototipo(entity, this.prototipoForm.typeView);
    }

    /**
     * 
     * @param entity
     */
    public clonePrototipo(entity: PrototipoDTO): void {

        this.prototipoForm.typeView = 'Clonar';

        this.getPrototipo(entity, this.prototipoForm.typeView);
    }

    /**
     * 
     * @param entity
     */
    public editarPrototipo(entity: PrototipoDTO): void {

        this.prototipoForm.typeView = 'Editar';

        this.getPrototipo(entity, this.prototipoForm.typeView);
    }

    /**
     * 
     * @param e
     */
    public onChangeTab(e): void {
        this.tabPrincipal = e.index;
    }

    /**
     * 
     * @param e
     */
    public onChangeTabEspacio(e): void {
        this.espacioForm.tab = e.index;
    }

    /**
     * 
     * @param e
     */
    public onChangeTabPrototipo(e): void {
        this.prototipoForm.tab = e.index;
    }

    /**
    * 
    * @param event
    * @param fileUpload
    */
    public onFileUpload(event: { files: File }, fileUpload): void {

        this.progressSpinner = true;

        console.log('onFileUpload -->> ', event)

        var excelParametros = { idPrototipo: this.prototipoForm.idPrototipo };

        this.service.AgregarDocumento(event, excelParametros).subscribe(resultado => {

            console.log('resultado -->> ', resultado);

            if (resultado.code == 200) {

                this.fileUpload.clear();

                this.editarPrototipo(this.prototipoForm.prototipoDetalle.prototipo)

                this.progressSpinner = false;

                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'Archivo(s) subido(s) ...', detail: '' });

                setTimeout(() => {
                    this.msgs = [];
                }, 4000);

            } else {

            }

        });;

    }

    /**
     * 
     * @param entity
     */
    public onChangeEspacioPublicar(entity: EspacioDTO): void {

        if (entity.activo == false) {
            entity.activo = null;
        }

        let dato: InputActualizarEstatusEspacio = <InputActualizarEstatusEspacio>{ idEspacios: [entity.idEspacio], activo: entity.activo };

        this.service.ActualizarEstatusEspacio(dato).subscribe(resultado => {

        });

    }

    /**
     * 
     * @param entity
     */
    public deleteEspacio(entity: EspacioDTO): void {

        this.servicioAlertas.mostrarConOpciones({
            title: "Simulador",
            text: `Está seguro de eliminar el prototipo`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {

            if (result.value) {

                let dato: InputActualizarEstatusEspacio = <InputActualizarEstatusEspacio>{ idEspacios: [entity.idEspacio], activo: false };

                this.service.ActualizarEstatusEspacio(dato).subscribe(resultado => {
                    this.ObtenerListaEspacio();
                });

            }

        })

    }

    /**
    * 
    * @param entity
    */
    public onChangePrototipoPublicar(entity: PrototipoDTO): void {

        if (entity.activo == false) {
            entity.activo = null;
        }

        let dato: InputActualizarEstatusPrototipo = <InputActualizarEstatusPrototipo>{ idPrototipos: [entity.idPrototipo], activo: entity.activo };

        this.service.ActualizarEstatusPrototipo(dato).subscribe(resultado => {

        });

    }

    /**
  * 
  * @param entity
  */
    public deletePrototipo(entity: PrototipoDTO): void {

        this.servicioAlertas.mostrarConOpciones({
            title: "Simulador",
            text: `Está seguro de eliminar el prototipo`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {

            if (result.value) {

                let dato: InputActualizarEstatusPrototipo = <InputActualizarEstatusPrototipo>{ idPrototipos: [entity.idPrototipo], activo: false };

                this.service.ActualizarEstatusPrototipo(dato).subscribe(resultado => {
                    this.ObtenerListaPrototipos();
                });

            }

        })

    }

    /**
    * 
    * @param entity
    */
    public deleteDocumento(entity: DocumentoDTO): void {

        console.error('deleteDocumento -->> ')

        this.servicioAlertas.mostrarConOpciones({
            title: "Simulador",
            text: `Está seguro de eliminar el documento`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {

            if (result.value) {

                let dato: InputActualizarEstatusDocumento = <InputActualizarEstatusDocumento>{ idDocumento: entity.idDocumento, documentoActivo: false };

                this.service.ActualizarEstatusDocumento(dato).subscribe(resultado => {

                    this.getPrototipo(this.prototipoForm.prototipoDetalle.prototipo, this.prototipoForm.typeView)

                });

            }

        })

    }

    private _getEspacio(espacioForm: EspacioForm, resultado: JsonResponse<OutputObtenerEspacioDetalle>) {

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            if (espacioForm.typeView == 'Detalle' || espacioForm.typeView == 'Editar') {
                espacioForm.idEspacio = resultado.model.espacio.idEspacio;
                espacioForm.nombreEspacio = resultado.model.espacio.nombreEspacio;
            }

            espacioForm.listaElementos = [];

            if (resultado.model.listElementos != null) {

                espacioForm.listaElementos = resultado.model.listElementos;

                for (let row of espacioForm.listaElementos) {
                    row.nombreElemento = row.nombreElementoEsp;
                }
            }

        }

    }

    /**
     * 
     * @param entity
     * @param typeView
     */
    private getEspacio(espacioForm: EspacioForm, entity: EspacioDTO): void {

        let dato: InputObtenerEspacioDetalle = <InputObtenerEspacioDetalle>{ idEspacio: entity.idEspacio };

        this.service.ObtenerEspacioDetalle(dato).subscribe((resultado: JsonResponse<OutputObtenerEspacioDetalle>) => {

            this._getEspacio(espacioForm, resultado);

        });

    }

    /**
     * 
     * @param entity
     */
    public async detalleEspacioPrototipo(entity: EspacioDTO) {

        this.prototipoForm.espacioForm.typeView = 'Editar';

        this.getEspacio(this.prototipoForm.espacioForm, entity);

        this.prototipoForm.tab = 2;
    }

    /**
     * 
     */
    public AgregarEspacio(): void {
        this.idElemento = 0;
        this.espacioForm.idEspacio = null;
        this.espacioForm.nombreEspacio = null;
        this.espacioForm.listaElementos = [];
        this.espacioForm.typeView = 'Agregar';
        this.espacioForm.tab = 1;
    }

    /**
     * 
     */
    public AgregarPrototipo(): void {
        this.idElemento = 0;
        this.prototipoForm.idPrototipo = null;
        this.prototipoForm.nombrePrototipo = null;
        this.prototipoForm.listEspacioSelect = [];
        this.prototipoForm.typeView = 'Agregar';
        this.prototipoForm.tab = 1;
        this.prototipoForm.prototipoDetalle = null;
    }

}
